<template>
  <div>
    <a-page-header style="width: 105%; margin-left: -20px" title="">
      <template slot="tags">
        <a-breadcrumb>
          <a-breadcrumb-item href="">
            <a-icon type="pie-chart" />
            <span>{{ $t("message.userGroupList.audience") }}</span>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="">
            <a-icon type="usergroup-add" />
            <span>{{ $t("message.userGroupList.uploadAudience") }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </template>
    </a-page-header>
    <div class="page-title">{{ $t("message.userGroupList.uploadAudience") }}</div>
    <a-spin :spinning="spinning">
      <a-card style="margin-top: 30px">
        <div>
          <span class="black-color"
            >{{ $t("message.uploadPackage.tabTitle1") }}：</span
          >
          <a-select :size="$globalSize"
            style="width: 70%"
            placeholder="请选择数据类型"
            ref="data_status"
            v-model="info_type"
          >
            <a-select-option value="phone">{{
              $t("message.uploadPackage.tabTitle4")
            }}</a-select-option>
            <!-- <a-select-option value="member_id">MemberID</a-select-option>
            <a-select-option value="union_id">UnionID</a-select-option> -->
            <a-select-option value="email">{{
              $t("message.uploadPackage.tabTitle9")
            }}</a-select-option>
          </a-select>
        </div>
        <a-card style="margin-top: 20px">
          <a-form-model ref="ruleForm">
            <a-form-model-item>
              <a-upload-dragger
                accept=".xlsx,.xls,.csv"
                name="file"
                :multiple="false"
                :before-upload="beforeUpload"
                @change="handleChange"
                :remove="removeFile"
                :file-list="fileList"
                class="upload-dragger"
              >
                <p class="ant-upload-drag-icon">
                  <a-icon type="inbox" style="color: #d46910" />
                </p>
                <p class="ant-upload-text">
                  <span style="color: blue">{{
                    $t("message.uploadPackage.tabTitle2")
                  }}</span
                  >{{ $t("message.uploadPackage.tabTitle5") }}
                </p>
                <p class="ant-upload-text">
                  <span style="color: orangered; font-size: 14px">{{
                    $t("message.uploadPackage.tabTitle10")
                  }}</span>
                </p>
              </a-upload-dragger>
            </a-form-model-item>
          </a-form-model>
          <div
            style="
              width: 100%;
              display: flex;
              justify-content: flex-end;
              grid-gap: 10px;
            "
          >
            <a-dropdown>
              <a-menu slot="overlay" @click="downloadDemo">
                <a-menu-item key="excel">
                  {{ $t("message.uploadPackage.tabTitle11") }}
                </a-menu-item>
                <a-menu-item key="csv">
                  {{ $t("message.uploadPackage.tabTitle12") }}
                </a-menu-item>
              </a-menu>
              <a-button  :size="$globalSize"  >
                {{ $t("message.uploadPackage.tabTitle13") }}

                <a-icon type="down" />
              </a-button>
            </a-dropdown>
            <a-button  :size="$globalSize" 
              type="primary"
              @click="uploadFile"
              style="
                float: right;
                min-width: 100px;
                margin-bottom: 20px;
              "
              
            >
              {{ $t("message.userGroupList.uploadAudience") }}
            </a-button>
          </div>
        </a-card>
      </a-card>
    </a-spin>
    <save-user-group-modal ref="saveUserGroupRef"></save-user-group-modal>
  </div>
</template>
<script>
import * as xlsx from "xlsx";
import saveUserGroupModal from "@/views/crowd/conponents/saveUserGroupModal";

export default {
  name: "UploadUserGroupPackage",
  components: {
    saveUserGroupModal,
  },
  data() {
    return {
      info_type: "",
      spinning: false,
      result: [],
      fileList: [],
      columns: [],
      showTable: false,
    };
  },
  mounted() {},
  methods: {
    beforeUpload() {
      return false;
    },
    parseCSVFileData(csvRecordsArray) {
      const csvData = [];
      for (let i = 1; i < csvRecordsArray.length; i++) {
        csvData.push(csvRecordsArray[i]);
      }
      return csvData;
    },
    handleChange(info) {
      if (info.file.status === "removed") return;
      this.fileList = [];
      this.fileList.push(info.file);
      info.fileList = this.fileList;
      let reader = new FileReader();
      reader.readAsBinaryString(info.file);
      reader.onload = () => {
        let fileData = reader.result;

        if (info.file.name.indexOf(".csv") > -1) {
          const csvRecordsArray = fileData.split(/\r\n|\n/);
          this.result = this.parseCSVFileData(csvRecordsArray).filter(
            (item) => item
          );
        } else {
          let wb = xlsx.read(fileData, { type: "binary", cellDates: true });
          let rowObj = xlsx.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], {
            header: 1,
          });
          const newArr = [];
          rowObj.forEach((item) => {
            newArr.push({ ...item });
          });
          if (rowObj.length) {
            const arr = [];
            for (let i = 0; i < rowObj[0].length; i++) {
              arr.push({
                dataIndex: i,
                key: i + new Date().getTime(),
              });
            }
            this.columns = arr;
          }
          newArr.shift();
          this.result = newArr.map((item) => item[0]).filter((item) => item);
        }
      };
    },
    uploadFile() {
      if (!this.fileList.length) {
        this.$message.error(this.$t("message.uploadPackage.tabTitle6"));
        return;
      }
      if (!this.info_type) {
        this.$message.error(this.$t("message.uploadPackage.tabTitle14"));
        return;
      }
      this.$refs.saveUserGroupRef.showModal(this.result, this.info_type);
    },
    downloadDemo(e) {
      const url =
        e.key === "csv"
          ? "https://bds-data.oss-cn-beijing.aliyuncs.com/dynames/template.csv"
          : "https://bds-data.oss-cn-beijing.aliyuncs.com/dynames/template.xlsx";
      window.open(url, "_self");
    },
    removeFile(file) {
      this.result = [];
      this.fileList = [];
      this.showTable = false;
      return true;
    },
  },
};
</script>
<style scoped lang="less">
.title {
  font-weight: 600;
}

.value {
  padding-left: 6px;
}

.upload-dragger ::v-deep .ant-upload.ant-upload-drag {
  border: 1px dashed #d46910 !important;
}
</style>
